/* aviso de cookies do rodape (sections/footer.liquid).
   regras:
   - a escolha vale pela api de privacidade da shopify: e ela que os pixels, os apps e o checkout obedecem. o tema
     guarda uma copia (localStorage nt-cookies) com data e versao so para saber quando perguntar de novo.
   - pergunta de novo depois de 12 meses (o mesmo prazo do registro da shopify, no cookie _shopify_essential) ou
     quando a versao muda (o liquid tira a versao das listas de ferramentas de analise e de marketing).
   - se a shopify perdeu a escolha (cookie apagado ou vencido) e a copia ainda vale, a copia volta para a shopify
     sem perguntar; se a api ainda nao tinha carregado na hora do clique, a escolha segue assim que ela chegar.
   - no brasil a loja e "ativo ate recusar" (escolha do dono, 7/10, com o brasil no automatico da shopify, que nao
     exige consentimento): sem resposta, analise e marketing seguem ligados. o x fecha o aviso sem escolher nada, fica
     guardado com a mesma validade e versao para o aviso nao voltar a cada pagina, e nao desliga nada.
   - as chaves do painel mostram o que esta valendo: a escolha guardada ou, sem ela, o que a shopify libera.
   - aceitar e rejeitar valem o mesmo. personalizar grava analise e marketing pelas chaves. preferencias nao tem
     chave porque o site nao usa ferramenta desse tipo: so o "aceitar tudo" liga. venda e compartilhamento de dados
     (sale_of_data) acompanha marketing, que e quando dado de navegacao e de compra vai para o google e o bixgrow.
   - recusar analise apaga os cookies de visitas do google (_ga); recusar marketing apaga os de campanha do google
     (_gcl) e os do afiliado bixgrow, que o app grava mesmo sem consentimento quando a pessoa chega por link de afiliado.
   - o aviso nasce escondido: quem ja respondeu nao ve piscar, e sem js ele nao aparece sem poder ser respondido. */
(() => {
  const raiz = document.querySelector('[data-nt-cook]');
  if (!raiz || raiz.ntCook) return;
  raiz.ntCook = true;

  const CHAVE = 'nt-cookies';
  const DIA = 864e5;
  const versao = raiz.dataset.versao || '1';
  const validade = (Number(raiz.dataset.validade) || 365) * DIA;
  const html = document.documentElement;
  const painel = raiz.querySelector('[data-nt-cook-painel]');
  const mais = raiz.querySelector('[data-nt-cook-personalizar]');
  const fechar = raiz.querySelector('[data-nt-cook-fechar]');
  const chave = {
    analytics: raiz.querySelector('[data-nt-cook-analise]'),
    marketing: raiz.querySelector('[data-nt-cook-marketing]'),
  };
  const editor = !!(window.Shopify && window.Shopify.designMode);
  let gatilho = null;
  let privacidade = null;

  const ler = () => {
    try {
      const r = JSON.parse(localStorage.getItem(CHAVE) || 'null');
      const idade = r && typeof r.em === 'number' ? Date.now() - r.em : NaN;
      if (r && r.v === versao && idade > -DIA && idade < validade) return r;
    } catch (e) {}
    return null;
  };
  const gravar = (r) => {
    try { localStorage.setItem(CHAVE, JSON.stringify(r)); } catch (e) {}
  };
  const escolheu = (r) => !!(r && !r.fechado);

  const achar = () => {
    const p = window.Shopify && window.Shopify.customerPrivacy;
    return p && typeof p.setTrackingConsent === 'function' ? p : null;
  };
  const api = new Promise((pronto) => {
    if (achar()) { pronto(achar()); return; }
    const desiste = setTimeout(() => pronto(achar()), 10000);
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (erro) => {
        clearTimeout(desiste);
        if (erro) console.warn('[nt] consent-tracking-api nao carregou', erro);
        pronto(achar());
      });
    } catch (e) {
      clearTimeout(desiste);
      console.warn('[nt] window.Shopify indisponivel', e);
      pronto(null);
    }
  }).then((p) => { privacidade = p; return p; });

  const enviar = (r) => api.then((p) => {
    if (!p) {
      console.warn('[nt] a escolha de cookies ficou so neste navegador; vai para a shopify na proxima pagina');
      return;
    }
    p.setTrackingConsent(
      { analytics: r.analytics, marketing: r.marketing, preferences: r.preferences, sale_of_data: r.sale_of_data },
      (res) => { if (res && res.error) console.warn('[nt] a shopify recusou a escolha de cookies', res.error); }
    );
  });

  const GOOGLE_ANALISE = /^(_ga|_ga_.+|_gid|_gat.*)$/;
  const MARKETING = /^(_gcl_.+|bgvisitor_id|bgaffilite_id|bglast_click|bgexpire_time|bgclick_id|bgcart)$/;
  const apagar = (padrao) => {
    const partes = location.hostname.split('.');
    document.cookie.split(';').forEach((par) => {
      const nome = par.split('=')[0].trim();
      if (!padrao.test(nome)) return;
      document.cookie = nome + '=; Max-Age=0; path=/';
      for (let i = 0; i < partes.length - 1; i++) {
        document.cookie = nome + '=; Max-Age=0; path=/; domain=.' + partes.slice(i).join('.');
      }
    });
  };
  const limpar = (r) => {
    if (!r.analytics) apagar(GOOGLE_ANALISE);
    if (!r.marketing) apagar(MARKETING);
  };

  /* so o clique em personalizar rola ate as categorias; reaberto pelo rodape, o aviso comeca do titulo e do x */
  const abrirPainel = (sim, rolar) => {
    painel.hidden = !sim;
    mais.setAttribute('aria-expanded', String(sim));
    raiz.classList.toggle('is-painel', sim);
    if (rolar && sim && raiz.scrollHeight > raiz.clientHeight) raiz.scrollTop = Math.max(0, painel.offsetTop - 16);
    else raiz.scrollTop = 0;
  };

  /* sem escolha guardada vale o que a shopify libera; antes da api chegar, ligado, que e a regra do brasil */
  const PERGUNTA = {
    analytics: 'analyticsProcessingAllowed',
    marketing: 'marketingAllowed',
    preferences: 'preferencesProcessingAllowed',
    sale_of_data: 'saleOfDataAllowed',
  };
  const liberado = (categoria) => {
    if (!PERGUNTA[categoria]) return false;
    const r = ler();
    if (escolheu(r)) return !!r[categoria];
    const p = privacidade || achar();
    const f = p && p[PERGUNTA[categoria]];
    return typeof f === 'function' ? !!f.call(p) : true;
  };
  const preencher = () => {
    chave.analytics.checked = liberado('analytics');
    chave.marketing.checked = liberado('marketing');
  };

  const mostrar = (pedido) => {
    preencher();
    raiz.hidden = false;
    raiz.classList.toggle('is-reaberto', !!pedido);
    html.classList.add('nt-cookies-abertas');
    abrirPainel(!!pedido);
    if (pedido) raiz.focus({ preventScroll: true });
  };

  const esconder = () => {
    const dentro = raiz.contains(document.activeElement);
    abrirPainel(false);
    raiz.hidden = true;
    html.classList.remove('nt-cookies-abertas');
    if (dentro && gatilho && gatilho.isConnected) gatilho.focus();
    gatilho = null;
  };

  const responder = (s) => {
    const r = {
      v: versao,
      em: Date.now(),
      analytics: !!s.analytics,
      marketing: !!s.marketing,
      preferences: !!s.preferences,
      sale_of_data: !!s.marketing,
    };
    gravar(r);
    limpar(r);
    esconder();
    document.dispatchEvent(new CustomEvent('nt:cookies', { detail: Object.assign({}, r) }));
    enviar(r);
  };

  raiz.querySelector('[data-nt-cook-tudo]').addEventListener('click', () => {
    responder({ analytics: true, marketing: true, preferences: true });
  });
  raiz.querySelector('[data-nt-cook-nao]').addEventListener('click', () => {
    responder({ analytics: false, marketing: false, preferences: false });
  });
  raiz.querySelector('[data-nt-cook-salvar]').addEventListener('click', () => {
    responder({ analytics: chave.analytics.checked, marketing: chave.marketing.checked, preferences: false });
  });
  /* o x nao muda nada; so na primeira vez, se a pessoa mexeu nas chaves antes de fechar, vale o que elas dizem. no editor nao grava */
  const dispensar = () => {
    const mexeu = !gatilho && !painel.hidden && (chave.analytics.checked !== liberado('analytics') || chave.marketing.checked !== liberado('marketing'));
    if (mexeu && !editor) {
      responder({ analytics: chave.analytics.checked, marketing: chave.marketing.checked, preferences: false });
      return;
    }
    if (!editor && !ler()) gravar({ v: versao, em: Date.now(), fechado: true });
    esconder();
  };
  mais.addEventListener('click', () => abrirPainel(painel.hidden, true));
  fechar.addEventListener('click', dispensar);

  /* esc fecha o painel; com o painel fechado, ou reaberto pelo rodape, vale o mesmo que o x */
  raiz.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    e.preventDefault();
    if (!painel.hidden && !gatilho) {
      abrirPainel(false);
      mais.focus();
    } else {
      dispensar();
    }
  });

  document.querySelectorAll('[data-nt-cook-abrir]').forEach((b) => {
    b.hidden = false;
    b.addEventListener('click', () => {
      gatilho = b;
      mostrar(true);
    });
  });

  window.ntCookies = {
    escolha: () => { const r = ler(); return escolheu(r) ? r : null; },
    permitido: (categoria) => liberado(categoria),
    abrir: () => mostrar(true),
  };

  /* o aviso vai para o comeco da pagina: e a primeira coisa que o teclado e o leitor de tela encontram */
  if (!editor && raiz.parentNode !== document.body) document.body.insertBefore(raiz, document.body.firstChild);

  /* com o aviso nativo da shopify ligado o nosso se cala: dois avisos na mesma tela e pior que nenhum */
  const nativo = () => document.getElementById('shopify-pc__banner') || window.privacyBanner;

  const guardada = ler();
  if (escolheu(guardada)) {
    limpar(guardada);
    api.then((p) => {
      if (!p || typeof p.currentVisitorConsent !== 'function') return;
      const v = p.currentVisitorConsent() || {};
      if (!v.analytics && !v.marketing) enviar(guardada);
    });
  } else if (!guardada && !editor && !nativo()) {
    mostrar(false);
    api.then((p) => {
      if (raiz.hidden || gatilho) return;
      if (nativo()) { esconder(); return; }
      /* quem ja recusou pela shopify (e a copia daqui venceu ou mudou de versao) nao ve de novo o "ja vem ligado" */
      const v = p && typeof p.currentVisitorConsent === 'function' ? p.currentVisitorConsent() || {} : {};
      if (v.analytics === 'no' && v.marketing === 'no') {
        gravar({ v: versao, em: Date.now(), analytics: false, marketing: false, preferences: false, sale_of_data: false });
        esconder();
        return;
      }
      if (painel.hidden) preencher();
    });
  }

  /* respondeu em outra aba: esta tambem fecha */
  window.addEventListener('storage', (e) => {
    if (e.key === CHAVE && ler() && !raiz.hidden && !gatilho) esconder();
  });

  if (editor) {
    document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(raiz)) mostrar(false); });
    document.addEventListener('shopify:section:deselect', (e) => { if (e.target.contains(raiz)) esconder(); });
  }
})();
